import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_files_pop_up = _resolveComponent("upload-files-pop-up")!
  const _component_upload_photos_pop_up = _resolveComponent("upload-photos-pop-up")!
  const _component_upload_all_pop_up = _resolveComponent("upload-all-pop-up")!
  const _component_upload_folder_pop_up = _resolveComponent("upload-folder-pop-up")!
  const _component_upload_case_pop_up = _resolveComponent("upload-case-pop-up")!
  const _component_comments_pop_up = _resolveComponent("comments-pop-up")!
  const _component_media_info_pop_up = _resolveComponent("media-info-pop-up")!
  const _component_media_info_old_pop_up = _resolveComponent("media-info-old-pop-up")!
  const _component_case_info_pop_up = _resolveComponent("case-info-pop-up")!

  return (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.UPLOAD_FILES)
    ? (_openBlock(), _createBlock(_component_upload_files_pop_up, { key: 0 }))
    : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.UPLOAD_PHOTOS)
      ? (_openBlock(), _createBlock(_component_upload_photos_pop_up, { key: 1 }))
      : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.UPLOAD_ALL)
        ? (_openBlock(), _createBlock(_component_upload_all_pop_up, { key: 2 }))
        : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.UPLOAD_FOLDER)
          ? (_openBlock(), _createBlock(_component_upload_folder_pop_up, { key: 3 }))
          : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.UPLOAD_CASE)
            ? (_openBlock(), _createBlock(_component_upload_case_pop_up, { key: 4 }))
            : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.COMMENTS)
              ? (_openBlock(), _createBlock(_component_comments_pop_up, { key: 5 }))
              : (_ctx.isMediaInfo)
                ? (_openBlock(), _createBlock(_component_media_info_pop_up, { key: 6 }))
                : (_ctx.isMediaInfoOld)
                  ? (_openBlock(), _createBlock(_component_media_info_old_pop_up, { key: 7 }))
                  : (_ctx.mainStore.BottomPopUpType === _ctx.CASE_BOTTOM_POPUP_TYPES.CASE_INFO)
                    ? (_openBlock(), _createBlock(_component_case_info_pop_up, { key: 8 }))
                    : _createCommentVNode("", true)
}